import { router } from "@inertiajs/vue3";
import axios from "axios";

const axiosInstance = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
});

axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response.status === 401) {
            router.get("/login");
        }

        return Promise.reject(error);
    },
);

export default axiosInstance;
